import { useState } from 'react'
import Input from '../ui/Input'
import { classNames } from '../../lib/classNames'

export default function QuickTodoRow({
    value,
    checked = false,
    disabled = false,
    saving = false,
    placeholder,
    registerRef,
    onValueChange,
    onCheck,
    onEnter,
    onBackspaceEmpty,
}) {
    const [justChecked, setJustChecked] = useState(false)

    const handleCheck = () => {
        if (justChecked || !onCheck) return
        setJustChecked(true)
        onCheck()
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault()
            onEnter?.()
        } else if (
            e.key === 'Backspace' &&
            value === '' &&
            e.currentTarget.selectionStart === 0 &&
            e.currentTarget.selectionEnd === 0
        ) {
            onBackspaceEmpty?.()
        }
    }

    const isChecked = checked || justChecked

    return (
        <div className="flex items-center gap-3 border-b-2 border-black dark:border-white py-2 last:border-b-0">
            <input
                type="checkbox"
                checked={isChecked}
                disabled={disabled || !onCheck || justChecked}
                onChange={handleCheck}
                className="size-5 shrink-0 accent-current disabled:cursor-not-allowed"
                aria-label="Mark done"
            />
            <Input
                ref={registerRef}
                value={value}
                onChange={(e) => onValueChange?.(e.target.value)}
                onKeyDown={handleKeyDown}
                disabled={disabled || justChecked}
                placeholder={placeholder}
                className={classNames(
                    'flex-1 border-none px-0 py-1 focus:ring-0 bg-transparent',
                    isChecked ? 'line-through opacity-60' : ''
                )}
                aria-label="Todo text"
            />
            {saving && <span className="text-xs text-blue-600 shrink-0">Saving…</span>}
        </div>
    )
}
